// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Gfvv","label":"Category_label__3t9cG","content":"Category_content__2gOZA","header":"Category_header__3JPnk","location":"Category_location__Io5b8"};